export default "//static.tradera.net/touchweb/static/output/images/category-stamp.be4cf05d.svg";